




























import Vue, { PropType } from 'vue';
import AdminGrid from '@/components/organisms/adminGrid/AdminGrid.vue';
import PageTemplate from '@/components/templates/pageTemplate/PageTemplate.vue';
import { Pagination } from '@/api/interfaces/common/pagination';
import { SpinnerState } from '@/enums/spinnerState';
import { AdminUpdateDataModel } from '@/types/app/admin/adminUpdateDataModel';
import { ApplicationStatusDetail } from '@/api/interfaces/content/common/applicationStatusDetail';

export default Vue.extend({
    name: 'AdminTemplate',
    components: {
        PageTemplate,
        AdminGrid,
    },
    props: {
        applications: {
            type: Array,
            required: true,
        },
        pagination: {
            type: Object as PropType<Pagination>,
            required: true,
        },
        nextApiDispatchAt: {
            type: String,
            default: null,
        },
        adminContent: {
            type: Object,
            required: true,
        },
        enumsContent: {
            type: Object,
            required: true,
        },
        applicationStatusItems: {
            type: Object as PropType<Record<
                string,
                ApplicationStatusDetail
            > | null>,
            default: null,
        },
        gridSpinner: {
            type: String as PropType<SpinnerState>,
            required: true,
        },
        adminUpdateData: {
            type: Object as PropType<AdminUpdateDataModel>,
            default: new AdminUpdateDataModel(),
        },
    },
});
